import { getTechnicianAvailability } from 'queries/technician/getTechnicianAvailability';
import { useQuery } from '@tanstack/react-query';

function useTechnicianAvailability(technicianId: string | number, fromDate: string) {
  const { data } = useQuery(
    ['technician', technicianId, 'availability', fromDate] as const,
    ({ queryKey: [_, id, _2, startDate] }) => getTechnicianAvailability(id, startDate),
    { enabled: !!technicianId && !!fromDate },
  );

  return [data];
}

export { useTechnicianAvailability };
